(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.menu-drawer__brand-search-input').forEach(function (input) {
      input.addEventListener('input', function () {
        var query = input.value.trim().toLowerCase();
        var submenu = input.closest('.menu-drawer__submenu');
        if (!submenu) return;
        var groups = submenu.querySelectorAll('.menu-drawer__letter-group');
        groups.forEach(function (group) {
          var items = group.querySelectorAll('.menu-drawer__letter-items > li');
          var anyVisible = false;
          items.forEach(function (item) {
            var text = item.textContent.trim().toLowerCase();
            var match = query === '' || text.indexOf(query) !== -1;
            item.style.display = match ? '' : 'none';
            if (match) anyVisible = true;
          });
          group.style.display = anyVisible ? '' : 'none';
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
